export class BatchItemHistory{

    label : string;
    value : string;

}